/*
 * Error boundaries do not catch errors for:
 * - Event handlers
 * - Asynchronous code
 * - Server side rendering
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { captureExceptionWithExtra } from 'error_tracker';
import { hot } from 'react-hot-loader';
import FullstoryUtil from 'fullstory_util';

class ErrorBoundary extends Component {
	static propTypes = {
		children: PropTypes.any,
	};

	constructor(props) {
		super(props);
		this.state = { error: null, errorInfo: null };
	}

	componentDidCatch(error, errorInfo) {
		// Display fallback UI
		this.setState({ error, errorInfo });
		// Log to error reporting service
		captureExceptionWithExtra(error, errorInfo);
		FullstoryUtil.sendEvent('errorBoundaryEvent');
		if (error?.name === 'ChunkLoadError') {
			// TODO: Do something smart here
			FullstoryUtil.sendEvent('ChunkLoadError');
		}
	}

	render() {
		if (this.state.errorInfo) {
			if (process.env.NODE_ENV !== 'production') {
				// Error path
				return <div>An error occurred.</div>;
			}
			// In production, dont render anything
			return null;
		}
		// Normally, just render children
		return this.props.children;
	}
}

export default hot(module)(ErrorBoundary);
